import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { Localized } from '../../localization/react'
import { Validity } from '../../typings/Product'

interface Props {
  validity: Validity
}

const CardValidityInformation: React.FC<React.PropsWithChildren<Props>> = ({ validity }) => {
  const validityStart = validity.startDate ? new Date(validity.startDate) : null

  return (
    <>
      <div>
        <Text size="small" color="subtleText">
          <Localized id="validity-start" />
        </Text>
        <Text>
          <Localized
            id="product-validity-start"
            params={{
              validityStartType: validity.startType as any,
              validityStart,
            }}
          />
        </Text>
      </div>
      <div>
        <Text size="small" color="subtleText">
          <Localized id="period-of-validity" />
        </Text>
        <Text>
          <Localized
            id="interval-including-single-number"
            params={{
              intervalValue: validity.duration.value,
              intervalType: validity.duration.type as any,
            }}
          />
        </Text>
      </div>
    </>
  )
}

export default CardValidityInformation
